import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
  SimpleLoading,
  PromotionalFooterPure,
  InputHLPure,
  ButtonHLPure,
  DropDownBtnHLPure,
  HeaderHLPure,
  DialogSystemGLPure,
  ArrowBtnHLPure,
  BoxSomeHeadersGLPure,
  TeamChatPure,
} from "../../pures";

import "./follow-up-actions-contracts.css";
import LabelPure from "../../pures/label/label.pure";
import FollowUpConfigurationsView from "./follow-up-actions-contracts-configuration.view";
import {
  CargarDocumento,
  EstampadoTiempoImage,
  DescargarDocumento,
  EditarDocumento,
  EliminarDocumento,
  GenerarContrato,
  newProfileIcon,
} from "../../../assets/logos/icons";
import ContractGeneratedView from "./questionsSection/contract-generated-view";
import PdfViewerAction from "../../actions/pdf-viewer/pdf-viewer.action";
import { ClientContractService, WorkflowService, QuestionnaireService } from "../../../services";
import DialogYesNoHLPure from "../../pures/dialogYesNoHL/dialogYesNoHL.pure";
import { changeFormatNumberToSend } from "../../../utils/convertFormatAnswer";
import { Tooltip } from "@progress/kendo-react-tooltip";

const FollowUpActionsContractsView = (props) => {
  const {
    clientContractId,
    loading,
    status,
    backBtnLabel,
    discussionBtnLabel,
    consultBtnLabel,
    validateBtnlabel,
    assignBtnLabel,
    titleView,
    btn1,
    btn2,
    btn3,
    btn4,
    btn5,
    btn6,
    btn6LabelWeb,
    btn6LabelMobil,
    contract,
    showLoadingRequesting,
    toggleLoadingRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequesting,
    workflowExecutionInfo,
    questions,
    token,
    user,
    workflowExecutionId,
    errorMessage,
    lawyers,
    createMessage,
    markChatAsRead,
    usersChat,
    conversation,
    membersChat,
    userHasPermission,
    handleFile,
    handleDeleteFile,
    selectedFile,
    contractIsPendingIn100505,
    renderComponentAgain,
    cancelContract
  } = props

  const { t } = useTranslation();
  let history = useHistory();

  const url = process.env.REACT_APP_MIFIRMA_API;
  const workflowService = new WorkflowService(url);
  const clientContractService = new ClientContractService(url);

  const mobileResolution = useMediaQuery("(max-width:660px)");

  const [messageDiscussion, setMessageDiscussion] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [leyendPdf, setLeyendPdf] = useState("");
  const [urlPdf, setUrlPdf] = useState("");
  const [questionsAnswered, setQuestionsAnswered] = useState([]);
  const [contractName, setContractName] = useState("");
  const [contractorName, setContractorName] = useState("");
  const [solicitudDate, setSollicitudDate] = useState("");
  const [contractorsName, setContractorsName] = useState("");
  const [btn2Label, setBtn2Label] = useState("");
  const [btn2Style, setBtn2Style] = useState({});
  const [btn6Style, setBtn6Style] = useState({});
  const [btn6Label, setBtn6Label] = useState("");
  const [headerTitle, setHeaderTitle] = useState("");
  const [lawyersToShow, setLawyersToShow] = useState([]);
  const [laywerAssigned, setLawyerAssigned] = useState(0);
  const [modalDeleteShow, setModalDeletShow] = useState(false);
  const [urlDocs, setUrlDocs] = useState("");
  const [filePdf, setFilePDF] = useState({});
  const [documentSelected, setDocumentSelected] = useState({})
  const [urlPdfModal, seturlPdfModalf] = useState('')
  const [showModalPdf, setShowModalPdf] = useState(false)
  const [renderComponent, setRenderComponent] = useState(false)
  const [heightCardTemplate, setHeightCardTemplate] = useState('1135px')
  const [showCancelContract, setShowCancelContract] = useState(true)
  const [labelCancelContract, setLabelCancelContract] = useState('')
  const [statusCancelContract, setStatusCancelContract] = useState(0)

  //renderiza el pdf y guarda la informacion en una variable para evitar que se actualice el pdfRender cuando se actuaiza el estado
  const pdf = useMemo(
    () => (
      <PdfViewerAction
        url={urlPdf}
        isExtended={true}
        isSSRActive={false}
        customHeight="1010px"
      />
    ),
    [urlPdf]
  );

  let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);


  const displayContainerQuestions = {
    display:
      Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510) ||
        Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100512) ||
        (Number(
          Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515)
        ) &&
          mobileResolution === false) ||
        (Number(
          Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520)
        ) &&
          mobileResolution === false) ||
        (Number(
          Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)
        ) &&
          mobileResolution === false) ||
        (Number(
          Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525)
        ) &&
          mobileResolution === false) ||
        (Number(
          Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100599)
        ) &&
          mobileResolution === false)
        ? "block"
        : "none",
    height: "500px",
  };

  const btn1Style = {
    marginRight: mobileResolution ? "0px" : "10px",
    display: "block",
  };

  const btn3Style = {
    marginRight: mobileResolution ? "0px" : "10px",
    display: mobileResolution ? btn3.displayMovil : btn3.displayComplete,
  };

  const btn4Style = {
    marginRight: mobileResolution ? "0px" : "10px",
    display: mobileResolution ? btn4.displayMovil : btn4.displayComplete,
  };

  const btn5Style = {
    marginRight: mobileResolution ? "0px" : "10px",
    display: mobileResolution ? btn5.displayMovil : btn5.displayComplete,
  };

  const cardDiscussionStyle = {
    height:
      status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510) ||
        status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100512) ||
        status === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525)
        ? "500px"
        : "500px",
    marginTop: "20px"
  };

  const btn3Label = mobileResolution === false ? btn3.labelComplete : btn3.labelMovil
  const btn4Label = mobileResolution === false ? btn4.labelComplete : btn4.labelMovil
  const btn5Label = mobileResolution === false ? btn5.labelComplete : btn5.labelMovil

  useEffect(() => {
    if (
      workflowExecutionInfo &&
      workflowExecutionInfo.workflowStatusDescriptions
    ) {
      let { statusBack } = workflowExecutionInfo.workflowStatusDescriptions;
      let { statusCurrent } = workflowExecutionInfo.workflowStatusDescriptions;
      let { statusNext } = workflowExecutionInfo.workflowStatusDescriptions;

      if (contractIsPendingIn100505) {
        let messageWaitForContractor = t("followUpActionsContractsView-modal.modal.status.100505")
        toggleLoadingRequesting(false)
        toggleErrorRequesting(true, messageWaitForContractor)
        setTimeout(() => {
          history.push("/");
          return;
        }, 4000)
      }

      let labelBtn2 = statusBack && Number(statusBack.status) > 0 ? `${statusBack.name}` : ''
      let displayBtn2 = (statusBack && Number(statusBack.status) > 0 && userHasPermission) ? 'block' : 'none'
      let labelBtn6 = statusNext && Number(statusNext.status) > 0 ? `${statusNext.name}` : ''
      let displayBtn6 = (statusNext && Number(statusNext.status) > 0 && userHasPermission) ? 'block' : 'none'
      let showCancelContractBtn = (statusCurrent && statusCurrent.statusCancel && userHasPermission) ? true : false
      let labelCancelContractBtn = (statusCurrent && statusCurrent.statusCancel && statusCurrent.statusCancel.label && userHasPermission) ? statusCurrent.statusCancel.label : ''
      let statusCancelContract = (statusCurrent && statusCurrent.statusCancel && statusCurrent.statusCancel.status && userHasPermission) ? statusCurrent.statusCancel.status : 0

      const btn2 = {
        display: displayBtn2,
      };

      const btn6 = {
        display: displayBtn6,
      };
      let header = `${t(
        "followUpActionsContractsView.label.title"
      )} ${titleView}`;

      setHeaderTitle(header);
      setBtn2Label(labelBtn2);
      setBtn6Label(labelBtn6);
      setBtn2Style(btn2);
      setBtn6Style(btn6);
      setShowCancelContract(showCancelContractBtn)
      setLabelCancelContract(labelCancelContractBtn)
      setStatusCancelContract(statusCancelContract)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowExecutionInfo, contractIsPendingIn100505]);


  useEffect(() => {
    if (!status) return
    let heightCard = '1135px'
    if (Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) || Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) || Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)) {
      heightCard = userHasPermission ? '1063px' : '1135px'
    }
    setHeightCardTemplate(heightCard)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, userHasPermission])


  useEffect(() => {
    if (
      Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510)
    ) {
      setLeyendPdf("PDF DEL CONTRATANTE");
    } else if (
      Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515)
    ) {
      setLeyendPdf("WORD DOCUMENT TEMPLATE");
    } else if (
      Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) || Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)
    ) {
      setLeyendPdf("WORD DOCUMENT CONTRATO GENERADO");
    } else if (
      Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525)
    ) {
      setLeyendPdf("PDF CONTRATO GENERADO");
    } else {
      setLeyendPdf("WORD DOCUMENT TEMPLATE");
    }
  }, [status]);

  useEffect(() => {
    if (contract && contract.contractors) {
      let contractors = "";
      setContractName(contract.name);
      setContractorName(contract.user.email);
      setSollicitudDate(contract.createdDate);
      for (let index = 0; index < contract.contractors.length; index++) {
        let nameContract = contract.contractors[index].contractor.name;
        if (index === 0) {
          contractors = `${nameContract}`;
        } else {
          contractors = `${contractors}, ${nameContract}`;
        }
      }
      setContractorsName(contractors)

      //Set pdf template
      if (urlPdf === '') {
        setUrlPdf(contract.templateDocumentPathPdf)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract]);

  useEffect(() => {
    if (Number(status) >= Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520)) {
      let urlContract = contract && contract.updatedDocumentPathPdf && contract.updatedDocumentPathPdf !== '' && contract.updatedDocumentPathPdf !== null && contract.updatedDocumentPathPdf !== undefined ? contract.updatedDocumentPathPdf : ''
      let urlContractDocs = contract && contract.updatedDocumentPathWord && contract.updatedDocumentPathWord !== '' && contract.updatedDocumentPathWord !== null && contract.updatedDocumentPathWord !== undefined ? contract.updatedDocumentPathWord : contract.originalDocumentPathWord
      setUrlPdf(urlContract)
      setUrlDocs(urlContractDocs)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, contract]);

  useEffect(() => {
    if (
      lawyers &&
      Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515)
    ) {
      let userId = user.userMetaData.userMifirma.id
      let allLawyers = [
        {
          name: t("followUpActionsContractsView.lawyer.name"),
          id: userId,
        },
      ];
      let lawyerId = contract && contract.userLawyerId ? contract.userLawyerId : userId;
      lawyers.map(lawyer => {
        let info = {}
        info.name = lawyer.firstName + ' ' + lawyer.firstLastName
        info.id = lawyer && lawyer.id ? lawyer.id : 0
        if (lawyer.firstName !== '' && lawyer.firstLastName !== '' && lawyer.active) {
          allLawyers.push(info)
        }
        return lawyer
      })
      setLawyerAssigned(lawyerId);
      setLawyersToShow(allLawyers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, contract, lawyers]);

  useEffect(() => {
    if (!renderComponent || renderComponent === false) return
    renderComponentAgain()
    setRenderComponent(false)
  }, [renderComponent])

  const handleInputMessageDiscussion = (e) => {
    setMessageDiscussion(e.target.value);
  };

  const handleDropDownLayerws = (e) => {
    let idLawyer = Number(e.target.value);
    setLawyerAssigned(idLawyer);
  };

  const handleChangeGeneral = (e) => {
    switch (Number(status) > 0) {
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_MOVIL_100510:
        handleBtnDiscussion();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_WEB_100515:
        handleBtnConsultQuestionnaire515();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_MOVIL_100515:
        handleBtnDiscussion();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_MOVIL_100520:
        handleBtnDiscussion();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_MOVIL_100520:
        handleBtnDiscussion();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) &&
        e.target.textContent === process.env.REACT_APP_BUTTON3_MOVIL_100525:
        handleBtnDiscussion();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) &&
        e.target.textContent === process.env.REACT_APP_BUTTON4_MOVIL_100525:
        handleBtnConsultQuestionnaire515();
        break;
      case Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100525) &&
        e.target.textContent === process.env.REACT_APP_BUTTON5_MOVIL_100525:
        handleRequestContract525();
        break;

      default:
        console.log("cayo en el default");
        break;
    }
  };

  const backButton = () => {
    history.goBack();
  };

  const handleBtnDiscussion = () => {
    setNameComponentUser("Discusion");
    setShowDetails(true);
  };

  const handleBtnConsultQuestionnaire515 = () => {
    setNameComponentUser("Consultar cuestionario");
    setShowDetails(true);
  };

  const handleRequestContract525 = () => {
    setNameComponentUser("Consultar contrato");
    setShowDetails(true);
  };

  const handleGenerateContract = async () => {
    toggleLoadingRequesting(true);
    try {
      // generate contract
      let clientContracId = clientContractId;
      let contractGenerated = await clientContractService.generateContract(
        clientContracId,
        token
      );
      if (
        contractGenerated &&
        contractGenerated.data &&
        Number(contractGenerated.statusCode) === 200
      ) {
        contractGenerated.data.documentPath &&
          setUrlPdf(contractGenerated.data.documentPath);
        contractGenerated.data.documentPathWord &&
          setUrlDocs(contractGenerated.data.documentPathWord);
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          toggleCompletedRequesting(false);
        }, 3000);
      } else {
        let messageError = t("followUpActionsContractsView-error-contract");
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, messageError);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {
      let messageError = t("followUpActionsContractsView-error-contract");
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  const handleUpload = async (e) => {
    toggleLoadingRequesting(true);
    let file = e.target.files[0];
    let clientContractFile = new FormData();
    clientContractFile.append("clientContractFile", file);
    clientContractFile.append("clientContractId", Number(clientContractId));
    try {
      // upload contract
      let uploadContract = await clientContractService.loadContract(
        clientContractFile,
        token
      );
      if (
        uploadContract &&
        uploadContract.data &&
        Number(uploadContract.statusCode) === 200
      ) {
        uploadContract.data.documentPath &&
          setUrlPdf(uploadContract.data.documentPath);
        uploadContract.data.documentPathWord &&
          setUrlDocs(uploadContract.data.documentPathWord);
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          toggleCompletedRequesting(false);
        }, 3000);
      } else {
        let messageError = t(
          "followUpActionsContractsView-error-upload-contract"
        );
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, messageError);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {
      let messageError = t(
        "followUpActionsContractsView-error-upload-contract"
      );
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  const handleEdit = () => {
    history.push({
      pathname: `/edit-docx/${clientContractId}`,
      state: { trackChangesGovo: false, type: "inboxTypeClientContract" },
    });
  };

  const handleDelete = async () => {
    setModalDeletShow(false);
    toggleLoadingRequesting(true);
    try {
      //Delete contract
      let deleteContract = await clientContractService.deleteContract(
        Number(clientContractId),
        token
      );
      if (
        deleteContract &&
        deleteContract.data &&
        Number(deleteContract.data.statusCode) === 200
      ) {
        setUrlPdf("");
        setUrlDocs("");
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          toggleCompletedRequesting(false);
        }, 3000);
      } else {
        let messageError = t(
          "followUpActionsContractsView-error-delete-contract"
        );
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, messageError);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {
      let messageError = t(
        "followUpActionsContractsView-error-delete-contract"
      );
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  //function to send next status
  const handleNextStatus = async () => {
    toggleLoadingRequesting(true);
    let messageError = "";
    try {
      if (
        Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510) ||
        Number(status) ===
        Number(process.env.REACT_APP_STATUS_WORK_FLOW_100512) ||
        Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) ||
        Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)
      ) {
        //verify if contract was generate
        if (
          (Number(status) ===
            Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) ||
            Number(status) ===
            Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)) &&
          urlPdf === ''
        ) {
          toggleLoadingRequesting(false);
          toggleErrorRequesting(
            true,
            t("followUpActionsContractsView-error-no-generate-contract")
          );
          setTimeout(() => {
            toggleErrorRequesting(false);
          }, 3000);
          return;
        }

        //save answers questions
        let answerList = questionsAnswered.map((question) => {
          if (question.format === 'number') {
            if (typeof question.value !== "number") {
              question.value = question.value.replaceAll(",", "");
            }

            let valueFormated = changeFormatNumberToSend(question.value, question.formatVariable.id);
            question.value = valueFormated
          }

          if (question.format === 'selection') {
            let singleType = question.selectorOptions.type[0].value
            if (singleType && !question.value) {
              question.value = question.selectorOptions.options[0].name
            }
          }

          return question
        })

        let questionSelectorExist = answerList.filter(question => question.format === 'selection')
        if (questionSelectorExist && questionSelectorExist.length > 0) {
          let questionHasNoValue = questionSelectorExist.find(question => !question.value)
          if (questionHasNoValue) {
            let messageError = 'Agregar una opción en la pregunta de tipo de selección.'
            toggleLoadingRequesting(false);
            toggleErrorRequesting(true, messageError);
            setTimeout(() => {
              toggleErrorRequesting(false);
            }, 4000);
            return
          }
        }

        let answer = await clientContractService.saveAnswersQuestionsContract(
          clientContractId,
          answerList,
          token
        );
        if (!answer || Number(answer.statusCode) !== 200) {
          messageError = t("followUpActionsContractsView-error-save-questions");
          throw new Error(messageError);
        }
      } else if (
        Number(status) === Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515)
      ) {
        let userLawyerId = laywerAssigned;
        //save id lawyer for conntract
        let saveIdLawyer = await clientContractService.assignLawyerForContract(
          clientContractId,
          userLawyerId,
          token
        );
        if (
          !saveIdLawyer ||
          !saveIdLawyer.data ||
          Number(saveIdLawyer.statusCode) !== 200
        ) {
          messageError = t("followUpActionsContractsView-error-save-lawyer");
          throw new Error(messageError);
        }
      } else {
      }
      let action = 1;
      //change status workflow to send next status
      let workflowChange = await workflowService.updateStatusWorkflow(
        workflowExecutionId,
        action,
        token
      );
      if (
        workflowChange &&
        workflowChange.data &&
        Number(workflowChange.statusCode) === 200
      ) {
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          if (workflowChange.data.stayInPage) {
            toggleLoadingRequesting(true)
            setRenderComponent(true)
          } else {
            let url = workflowChange.data.url
            history.push(url)
          }
        }, 4000);
      } else {
        messageError = "Error al ejecutar el servicio de workflow";
        throw new Error(messageError);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  //function to send status back
  const handleBackBtn = async () => {
    toggleLoadingRequesting(true);
    try {
      let action = 2;
      //change status workflow to back status
      let workflowChange = await workflowService.updateStatusWorkflow(
        workflowExecutionId,
        action,
        token
      );

      if (
        workflowChange &&
        workflowChange.data &&
        Number(workflowChange.statusCode) === 200
      ) {
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          if (workflowChange.data.stayInPage) {
            toggleLoadingRequesting(true)
            setRenderComponent(true)
          } else {
            let url = workflowChange.data.url
            history.push(url)
          }
        }, 3000);
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {

      toggleLoadingRequesting(false);
      toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  const closeDialogDelete = () => {
    setModalDeletShow(false);
  };

  const openDialogDelete = () => {
    setModalDeletShow(true);
  };

  const handleInputChange = (e) => {
    let file = e.target.files[0];
    setFilePDF(file);
    let reader = new FileReader();
  };

  const handleUpdateAnswerRawRecDoc = async () => {
    setShowModalPdf(false)
    toggleLoadingRequesting(true)
    let id = documentSelected.id
    let file = selectedFile
    let clientDocumentId = documentSelected.clientDocumentId
    let documentQuestion = new FormData();
    documentQuestion.append("documentQuestion", file);
    documentQuestion.append("id", id);
    documentQuestion.append("clientDocumentId", clientDocumentId);

    try {
      let documentUpdated = await questionnaireService.createDocumentAnswerRawRecDoc(documentQuestion, token)
      if (documentUpdated && documentUpdated.data && Number(documentUpdated.statusCode) === 200) {
        documentSelected.url = documentUpdated.data.url
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(true);
        setTimeout(() => {
          handleDeleteFile()
          toggleCompletedRequesting(false);
        }, 3000);
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true);
        setTimeout(() => {
          toggleErrorRequesting(false);
          setShowModalPdf(true)
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
        setShowModalPdf(true)
      }, 4000);
    }
  }

  const handleShowModal = (documento) => {
    seturlPdfModalf(documento.url)
    setDocumentSelected(documento)
    setShowModalPdf(true)
  }


  const handleCloseModal = () => {
    seturlPdfModalf('')
    setDocumentSelected({})
    handleDeleteFile()
    setShowModalPdf(false)
  }


  return (
    <div className="followUpActionsContractsView-wrapper">
      {loading ? (
        <SimpleLoading />
      ) : (
        <Container
          lg={12}
          md={12}
          spacing={4}
          className="followUpActionsContractsView-container"
        >
          {showLoadingRequesting ? (
            <DialogSystemGLPure
              toggleLoadingRequesting={toggleLoadingRequesting}
              showLoadingRequesting={showLoadingRequesting}
            />
          ) : null}
          {showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
            />
          ) : null}
          {showErrorRequesting ? (
            <DialogSystemGLPure
              toggleErrorRequesting={toggleErrorRequesting}
              message={errorMessage}
              showErrorRequesting={showErrorRequesting}
            />
          ) : null}
          <div className="followUpActionsContractsView-title-cotainer">
            <HeaderHLPure title={headerTitle} />
          </div>
          {showDetails && nameComponentUser ? (
            <FollowUpConfigurationsView
              nameComponentUser={nameComponentUser}
              hideShowDetails={() => {
                setShowDetails(false);
                setNameComponentUser("");
              }}
              setShowDetails={setShowDetails}
              setNameComponentUser={setNameComponentUser}
              status={status}
              setUrlPdf={setUrlPdf}
              setQuestionsAnswered={setQuestionsAnswered}
              conversation={conversation}
              usersChat={usersChat}
              handleInputChange={handleInputChange}
              createMessage={createMessage}
              onMarkAsRead={markChatAsRead}
              handleFile={handleFile}
              handleDeleteFile={handleDeleteFile}
              handleShowModal={handleShowModal}
              urlPdfModal={urlPdfModal}
              showModalPdf={showModalPdf}
              documentSelected={documentSelected}
              handleCloseModal={handleCloseModal}
              handleUpdateAnswerRawRecDoc={handleUpdateAnswerRawRecDoc}
              {...props}
            />
          ) : (
            <>
              <Grid
                container
                className="followUpActionsContractsView-body"
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
              >
                <BoxSomeHeadersGLPure
                  titleOne={t("followUpActionsContractsView.contract")}
                  subtitleOne={contractName}
                  titleTwo={t("followUpActionsContractsView.solicitante")}
                  subtitleTwo={contractorName}
                  titleThree={t("followUpActionsContractsView.date.request")}
                  subtitleThree={solicitudDate}
                  titleFour={t(
                    "followUpActionsContractsView.companys.contractor"
                  )}
                  subtitleFour={contractorsName}
                />
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className="followUpActionsContractsView-cards-container"
                >
                  <div className="followUpActionsContractsView-container-right">
                    <div
                      className="followUpActionsContractsView-container-questions"
                      style={displayContainerQuestions}
                    >
                      <ContractGeneratedView
                        contractName="Contrato de prueba"
                        hideShowDetails={() => {
                          setShowDetails(false);
                          setNameComponentUser("");
                        }}
                        isMobile={false}
                        status={status}
                        setUrlPdf={setUrlPdf}
                        setQuestionsAnswered={setQuestionsAnswered}
                        questions={questions}
                        token={token}
                        clientContractId={clientContractId}
                        heightContainer={"470px"}
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        userHasPermission={userHasPermission}
                        handleFile={handleFile}
                        handleDeleteFile={handleDeleteFile}
                        handleShowModal={handleShowModal}
                        urlPdfModal={urlPdfModal}
                        showModalPdf={showModalPdf}
                        documentSelected={documentSelected}
                        handleCloseModal={handleCloseModal}
                        handleUpdateAnswerRawRecDoc={handleUpdateAnswerRawRecDoc}
                        {...props}
                      />
                    </div>
                    <div
                      className="followUpActionsContractsView-card-discussion"
                      style={cardDiscussionStyle}
                    >
                      <TeamChatPure
                        usersChat={usersChat}
                        conversation={conversation}
                        membersChat={membersChat}
                        handleInputChangeChat={handleInputChange}
                        createMessage={createMessage}
                        onMarkAsRead={markChatAsRead}
                        titleChat={t("followUpActionsContractsView.team.contract")}
                        widthChat={1200}
                        heightChat={500}
                        containerHeight={cardDiscussionStyle.height}
                        titlePanel={t('newSignatureDetailView.comments.binnacle')}
                      />
                    </div>
                  </div>
                  <div className="followUpActionsContractsView-container-left">
                    {Number(status) ===
                      Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515) && userHasPermission
                      ? (
                        <div className="followUpActionsContractsView-card-asign">
                          <DropDownBtnHLPure
                            labelDropDown={t(
                              "followUpActionsContractsView.layer.assigned"
                            )}
                            optionsDropDown={lawyersToShow}
                            nameOption={"name"}
                            valueItem={"id"}
                            onDropDownChange={(e) => handleDropDownLayerws(e)}
                            optionsValue={laywerAssigned}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    {(Number(status) ===
                      Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) || Number(status) ===
                      Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)) && userHasPermission
                      ? (
                        <div className="followUpActionsContractsView-card-section-btns">
                          <div
                            className="followUpActionsContractsView-div-generate"
                            onClick={handleGenerateContract}
                          >
                            <img
                              alt="generateContract"
                              className=""
                              src={GenerarContrato}
                              width="50px"
                            ></img>
                            <div className="followUpActionsContractsView-label-btn-generate">
                              <h5>
                                {t(
                                  "followUpActionsContractsView-generate-contract"
                                )}
                              </h5>
                            </div>
                          </div>
                          <div className="followUpActionsContractsView-div-download">
                            <a className="" href={urlDocs} download>
                              <img
                                alt="dowloadDocument"
                                className=""
                                src={DescargarDocumento}
                                width="50px"
                              ></img>
                            </a>
                            <div className="followUpActionsContractsView-label-btn-download">
                              <h5>
                                {t("followUpActionsContractsView-download-docx")}
                              </h5>
                            </div>
                          </div>
                          <div className="followUpActionsContractsView-load-container">
                            <div className="followUpActionsContractsView-input-file-load">
                              <img
                                alt="uploadDocument"
                                className="followUpActionsContractsView-image-upload"
                                src={CargarDocumento}
                              ></img>
                              <input
                                type="file"
                                // id="fileKey"
                                className="followUpActionsContractsView-load-file"
                                accept="application/docx"
                                onChange={(e) => {
                                  handleUpload(e);
                                }}
                              />
                            </div>
                            <div className="followUpActionsContractsView-label-btn-upload">
                              <h5>
                                {t("followUpActionsContractsView-upload-docx")}
                              </h5>
                            </div>
                          </div>
                          <div
                            className="followUpActionsContractsView-div-edit"
                            onClick={handleEdit}
                          >
                            <img
                              alt="editDocument"
                              className=""
                              src={EditarDocumento}
                              width="50px"
                            ></img>
                            <div className="followUpActionsContractsView-label-btn-edit">
                              <h5>
                                {t("followUpActionsContractsView-edit-docx")}
                              </h5>
                            </div>
                          </div>
                          <div
                            className="followUpActionsContractsView-div-delete"
                            onClick={openDialogDelete}
                          >
                            <img
                              alt="deleteDocument"
                              className=""
                              src={EliminarDocumento}
                              width="50px"
                            ></img>
                            <div className="followUpActionsContractsView-label-btn-delete">
                              <h5>
                                {t("followUpActionsContractsView-delete-docx")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    <div
                      className="followUpActionsContractsView-template-container"
                      style={{ height: heightCardTemplate }}
                    >
                      {Number(status) !== process.env.REACT_APP_STATUS_WORK_FLOW_100522 && urlPdf && pdf}
                    </div>
                  </div>
                </Grid>
                <div className="followUpActionsContractsView-btns-container">
                  <div className="" style={btn1Style}>
                    <ButtonHLPure
                      nameBtn={t("followUpActionsContractsView.button.exit")}
                      primary={false}
                      onClickBtn={(e) => backButton(e)}
                    />
                  </div>
                  <div
                    className="followUpActionsContractsView-btn2"
                    style={btn2Style}
                  >
                    <ButtonHLPure
                      nameBtn={btn2Label}
                      primary={false}
                      onClickBtn={(e) => handleBackBtn(e)}
                    />
                  </div>
                  <div className="" style={btn3Style}>
                    <ArrowBtnHLPure
                      textArrowBtn={btn3Label}
                      primary={
                        mobileResolution
                          ? btn3.primaryMovil
                          : btn3.primaryComplete
                      }
                      onClickArrowBtn={(e) => handleChangeGeneral(e)}
                    />
                  </div>
                  <div className="" style={btn4Style}>
                    <ArrowBtnHLPure
                      textArrowBtn={btn4Label}
                      primary={
                        mobileResolution
                          ? btn4.primaryMovil
                          : btn4.primaryComplete
                      }
                      onClickArrowBtn={(e) => handleChangeGeneral(e)}
                    />
                  </div>
                  <div className="" style={btn5Style}>
                    <ArrowBtnHLPure
                      textArrowBtn={btn5Label}
                      primary={
                        mobileResolution
                          ? btn5.primaryMovil
                          : btn5.primaryComplete
                      }
                      onClickArrowBtn={(e) => handleChangeGeneral(e)}
                    />
                  </div>
                  {
                    showCancelContract ?
                      <div className="followUpActionsContractsView-secondary-btns">
                        <ButtonHLPure
                          nameBtn={labelCancelContract}
                          primary={false}
                          onClickBtn={() => cancelContract(statusCancelContract)}
                        />
                      </div>
                      : null
                  }
                  <div className="" style={btn6Style}>
                    <ButtonHLPure
                      nameBtn={btn6Label}
                      primary={true}
                      onClickBtn={(e) => handleNextStatus(e)}
                    />
                  </div>
                </div>
              </Grid>
              {modalDeleteShow && (
                <DialogYesNoHLPure
                  cancel={closeDialogDelete}
                  textBtnCancel={t("button.cancel")}
                  saveBtn={t("followUpActionsContractsView.button.delete")}
                  titleDialog={t(
                    "followUpActionsContractsView.dialog.delete.title"
                  )}
                  loadingComponent={loading}
                  handleSubmit={handleDelete}
                >
                  <h1>
                    {t(
                      "followUpActionsContractsView.dialog.delete.description"
                    )}
                  </h1>
                </DialogYesNoHLPure>
              )}
            </>
          )}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <PromotionalFooterPure />
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default FollowUpActionsContractsView;
